let langValue = $(".guide-lang").val();


$(".guide-lang").change(function () {

    langValue = $(this).val();
    let guidesList = $(this).parent().parent().next('.our-guides-block__guides-page-list-wrapper')
    let dataLocation = guidesList.attr('data-location');
    let checkoutPreloader = $(this).parent().parent().next('.our-guides-block__guides-page-list-wrapper').find(".checkout-cards__preloader");
    checkoutPreloader.addClass("show");
    $.ajax({
        type: "POST",
        url: themeVars.ajax_url,
        data: {
            action: "guideLangValue",
            language: langValue,
            location: dataLocation,
        },
        success: function (response) {
            checkoutPreloader.removeClass("show");
            guidesList.html(response);
        },
    });
});

$(document).on('click', '.our-guides-block__more-guides-link', function (e) {
    e.preventDefault();

    langValue = $(this).parent().parent().siblings().find('.guide-lang').val();
    let checkoutPreloader = $(this).parent().siblings(".checkout-cards__preloader");
    checkoutPreloader.addClass("show");

    let guidesList = $(this).parent().parent();
    let linkBlock = $(this).parent();
    let dataLocation = guidesList.attr('data-location');

    $.ajax({
        type: "POST",
        url: themeVars.ajax_url,
        data: {
            action: "loadAllGuides",
            postsPerPage: "-1",
            language: langValue,
            location: dataLocation,
        },
        success: function (response) {
            checkoutPreloader.removeClass("show");
            guidesList.html(response);
            linkBlock.hide();
        },
    })
})  


// WEBPACK FOOTER //
// ./scripts/modules/about-us.js